import { messages as portugueseMessages } from "./pt";
import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";
import { messages as italianMessages } from "./it";
import { messages as esExtra } from "./es_extra";
import { messages as itExtra } from "./it_extra";
import { messages as enExtra } from "./en_extra";
import { messages as ptExtra } from "./pt_extra";

const messages = {
	...portugueseMessages,
	...englishMessages,
	...spanishMessages,
	...italianMessages,
	// Merge extra translations into each language (new top-level keys inside translations)
	es: {
		...spanishMessages.es,
		translations: {
			...(spanishMessages.es?.translations || {}),
			...(esExtra.es?.translations || {}),
		},
	},
	it: {
		...italianMessages.it,
		translations: {
			...(italianMessages.it?.translations || {}),
			...(itExtra.it?.translations || {}),
		},
	},
	en: {
		...englishMessages.en,
		translations: {
			...(englishMessages.en?.translations || {}),
			...(enExtra.en?.translations || {}),
		},
	},
	pt: {
		...portugueseMessages.pt,
		translations: {
			...(portugueseMessages.pt?.translations || {}),
			...(ptExtra.pt?.translations || {}),
		},
	},
};

export { messages };
